<nb-card>
  <nb-card-header class="d-flex justify-content-between align-items-center">
    <div>
      <h3>Email Templates</h3>
      <small>Create and manage transactional email templates</small>
    </div>
    <div>
      <button nbButton status="primary" size="small" (click)="onCreateTemplate()">Create Template</button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="filters-row d-flex align-items-center" style="gap: 8px; margin-bottom: 12px">
      <nb-form-field>
        <nb-icon nbPrefix icon="funnel-outline"></nb-icon>
        <nb-select placeholder="Active" [formControl]="activeFilterControl" size="small">
          <nb-option [value]="true">Active</nb-option>
          <nb-option [value]="false">Inactive</nb-option>
        </nb-select>
      </nb-form-field>
      <nb-form-field>
        <nb-icon nbPrefix icon="layers-outline"></nb-icon>
        <nb-select placeholder="Type" [formControl]="systemTemplateControl" size="small">
          <nb-option value="">All</nb-option>
          <nb-option value="false">Custom</nb-option>
          <nb-option value="true">System</nb-option>
        </nb-select>
      </nb-form-field>
    </div>

    <div class="templates-grid" *ngIf="!loading">
      <div class="template-card" *ngFor="let template of templates" [class.inactive]="!template.is_active">
        <!-- Template Header -->
        <div class="template-header">
          <div class="template-icon">
            <svg viewBox="0 0 24 24" class="icon">
              <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
            </svg>
          </div>
          <div class="template-meta">
            <h3 class="template-name">{{ template.name }}</h3>
            <p class="template-subject">{{ template.subject }}</p>
            <p class="template-description">{{ template.description || 'No description provided' }}</p>
          </div>
          <div class="template-badges">
            <span class="status-badge" [class.active]="template.is_active" [class.inactive]="!template.is_active">
              {{ template.is_active ? 'Active' : 'Inactive' }}
            </span>
            <span class="system-badge" *ngIf="template.is_system_template">System</span>
          </div>
        </div>

        <!-- Template Info -->
        <div class="template-info">
          <div class="info-item">
            <span class="label">Slug:</span>
            <code class="value">{{ template.slug }}</code>
          </div>
          <div class="info-item">
            <span class="label">Created:</span>
            <span class="value">{{ template.created_at | date : 'short' }}</span>
          </div>
          <div class="info-item">
            <span class="label">Last Updated:</span>
            <span class="value">{{ template.updated_at | date : 'short' }}</span>
          </div>
        </div>

        <!-- Template Actions -->
        <div class="template-actions">
          <button class="action-btn primary" (click)="onEditTemplate(template)" title="Edit Template">
            <svg viewBox="0 0 24 24" class="icon">
              <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" />
            </svg>
            Edit
          </button>
          <button class="action-btn secondary" (click)="onDuplicateTemplate(template)" title="Duplicate Template">
            <svg viewBox="0 0 24 24" class="icon">
              <path d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" />
            </svg>
            Duplicate
          </button>
          <button class="action-btn toggle" (click)="onToggleStatus(template)" [title]="template.is_active ? 'Deactivate' : 'Activate'">
            <svg viewBox="0 0 24 24" class="icon" *ngIf="template.is_active">
              <path
                d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"
              />
            </svg>
            <svg viewBox="0 0 24 24" class="icon" *ngIf="!template.is_active">
              <path
                d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.09L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.76,7.13 11.37,7 12,7Z"
              />
            </svg>
            {{ template.is_active ? 'Disable' : 'Enable' }}
          </button>
          <button
            class="action-btn danger"
            (click)="onDeleteTemplate(template)"
            [disabled]="template.is_system_template"
            [title]="template.is_system_template ? 'Cannot delete system template' : 'Delete Template'"
          >
            <svg viewBox="0 0 24 24" class="icon">
              <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
            </svg>
            Delete
          </button>
        </div>
      </div>
    </div>

    <div class="loading-state" *ngIf="loading">
      <div class="spinner"></div>
      <p>Loading templates...</p>
    </div>

    <div class="empty-state" *ngIf="!loading && templates.length === 0">
      <div class="empty-icon">
        <svg viewBox="0 0 24 24">
          <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
        </svg>
      </div>
      <h3>No Templates Found</h3>
      <p>Create your first email template to get started</p>
      <button class="create-btn" (click)="onCreateTemplate()">
        <svg viewBox="0 0 24 24" class="icon">
          <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
        </svg>
        Create First Template
      </button>
    </div>
  </nb-card-body>
</nb-card>
